import { VIEW_TESTIMONIAL_DATA } from "../../constants";

export function viewTestimonial(data) {
    return {
        type: VIEW_TESTIMONIAL_DATA,
        data
    };
}